module.exports = __webpack_public_path__ + "img/img-118.38780164.png";